import { PlayerConfig } from '../pages/Quiz/QuizGame';

export const RACHIT_CONFIG: PlayerConfig = {
  playerName: 'Rachit',
  localStorageKey: 'rachit-quiz-state',
  pageTitle: "Rachit's Quiz 🎓",

  questionTypes: [
    'math_multiplication',
    'math_word_problem_easy',
    'science_animals',
    'vocabulary_grade4',
    'math_patterns',
    'fun_space_facts',
    'math_division_simple',
    'geography_usa_world',
    'mythology_legends',
    'math_measurement_time',
    'language_grammar',
    'fun_lego_inventions',
  ],

  difficultyConfig: {
    0: { label: 'Normal 📗', desc: 'Standard Grade 4 difficulty. Achievable with solid effort. Build confidence.' },
    1: { label: 'Harder 📙', desc: 'A notch above Grade 4. Slightly larger numbers, less obvious distractors, mild multi-step reasoning.' },
    2: { label: 'Challenge 📕', desc: 'Grade 5–6 stretch. Multi-step problems, deeper vocabulary, trickier patterns.' },
  },

  typeInstructions: {
    math_multiplication: `Multiplication facts or expressions for Grade 4 (up to 12×12).`,
    math_word_problem_easy: `A SHORT, 1-2 step word problem for Grade 4.`,
    science_animals: `An interesting animal science fact question for a curious 10-year-old.`,
    vocabulary_grade4: `A Grade 4 vocabulary question.`,
    math_patterns: `A number pattern or shape pattern question for Grade 4.`,
    fun_space_facts: `A fun space/astronomy fact question that a 10-year-old would find mind-blowing.`,
    math_division_simple: `Simple whole-number division for Grade 4 with NO remainders.`,
    geography_usa_world: `Geography question for Grade 4.`,
    mythology_legends: `A question about Greek/Roman mythology OR Indian mythology.`,
    math_measurement_time: `Measurement or time question for Grade 4.`,
    language_grammar: `A fun grammar question for Grade 4 ELA.`,
    fun_lego_inventions: `A fun trivia question about LEGO, famous inventions, or cool technology.`,
  },

  personaPrompt: `You are a warm, encouraging quiz host for Rachit, a smart and creative 10-year-old in Grade 4 in Dublin, California. He loves LEGO, space, animals, and mythology.`,

  specialRules: '',
};
